"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2016],{

/***/ 52016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_components_CookieContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82293);



function HTMLSnippet(param) {
    var htmlSnippet = param.htmlSnippet;
    var divRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var consentGiven = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(shared_components_CookieContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .CookieContext */ .U).consentGiven;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (consentGiven) {
            var fragment = document.createRange().createContextualFragment(htmlSnippet);
            divRef.current.append(fragment);
        }
    }, [
        consentGiven
    ]);
    if (!consentGiven) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: divRef
    });
}
/* harmony default export */ __webpack_exports__["default"] = (HTMLSnippet);


/***/ })

}]);